export const ConsumerEmailFormUat = {
  submitButton: 'consumerEmail.submitButton',
  input: 'consumerEmail.input',
}
